// services/konto6Format.js — колоните на файла „Импорт на документи" в
// Конто 6 и форматите на датите (ПРОМТ-11). ЕДНО място за продажбите и
// доставките: services/kontoRows.js строи и двете върху тези COLS. Изнесено
// дословно от kontoRows.js — test/konto-export-unchanged.test.js пази, че
// файлът на фирма без склад е клетка по клетка същият.

const HEADL = ['Тип на документа', 'Номер на документа', 'Дата на документа', 'Вальор', 'Дата на данъчно събитие', 'По документ', 'Код на номенклатура за тип контрагент', 'Код на контрагента', 'Име на контрагента', 'Булстат на контрагента', 'ИН по ДДС на контрагента', 'Адрес на контрагента', 'Име на МОЛ', 'Код на вид плащане', 'Падеж', 'Стойност на документа в локална валута', 'Стойност на ДДС в локална валута', 'Код валута', 'Валутен курс', 'Стойност на документа в чужда валута', 'Стойност на ДДС в чужда валута', 'Обяснителен текст'];
const DETL = ['Номер на ред от документа', 'Код вид сделка ДДС', 'Код на номенклатура за тип артикул', 'Код на артикул', 'Име на артикул', 'Код на показател мярка', 'Количество', 'Единична цена в локална валута', 'Единична цена във валута', 'ДДС в локална валута', 'ДДС във валута', 'Стойност в локална валута', 'Стойност във валута', 'Стойност ДДС в локална валута', 'Стойност ДДС във валута', 'Обяснителен текст'];
const HEADC = ['H.DOC_TYPE', 'H.DOC_NO', 'H.DOC_DATE', 'H.DOC_VALEUR', 'H.TAX_EVENT_DATE', 'H.FROM_DOC', 'H.PARTNER_TYPE', 'H.PARTNER', 'P.PARTNER_NAME', 'P.PARTNER_ID', 'P.PARTNER_VAT_ID', 'H.PARTNER_ADDRESS', 'H.PARTNER_MOLL', 'H.PAYMENT_TYPE', 'H.DUE_DATE', 'H.VALUE_LOCAL', 'H.VAT_LOCAL', 'H.CURRENCY', 'H.EXCHANGE_RATE', 'H.VALUE_FOREIGN', 'H.VAT_FOREIGN', 'H.DESCRIPTION'];
const DETC = ['D.ROW_NO', 'D.DEAL_TYPE', 'D.ARTICLE_TYPE', 'D.ARTICLE_ID', 'A.ARTICLE_NAME', 'D.MEASURE', 'D.QTY', 'D.PRICE_LOCAL', 'D.PRICE_FOREIGN', 'D.PRICE_VAT_LOCAL', 'D.PRICE_VAT_FOREIGN', 'D.VALUE_LOCAL', 'D.VALUE_FOREIGN', 'D.VAT_LOCAL', 'D.VAT_FOREIGN', 'D.DESCRIPTION'];

function rek() { const o = []; for (let k = 1; k <= 20; k++) o.push('Допълнителен реквизит ' + k); return o; }
function hf(p) { const o = []; for (let k = 1; k <= 20; k++) o.push(p + '.FIELD_' + k); return o; }

const LABELS = HEADL.concat(rek(), DETL, rek());
const COLS = HEADC.concat(hf('H'), DETC, hf('D'));
const CI = {};
COLS.forEach((c, i) => { CI[c] = i; });

// Краят на месеца на дата ISO (вальорът).
function eom(s) {
  if (!s) return '';
  s = String(s);
  const y = +s.slice(0, 4), m = +s.slice(5, 7);
  const last = new Date(y, m, 0).getDate();
  return s.slice(0, 4) + '-' + ('0' + m).slice(-2) + '-' + ('0' + last).slice(-2);
}
// ISO → dd.mm.yyyy.
function df(s) {
  s = String(s || '').slice(0, 10);
  const p = s.split('-');
  return (p.length === 3) ? p[2] + '.' + p[1] + '.' + p[0] : s;
}

module.exports = { HEADL, DETL, HEADC, DETC, LABELS, COLS, CI, eom, df };
